import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}

export function getPartnerList(params) {
  return request({
    url: '/api/user',
    method: 'get',
    params
  })
}

export function getUserList(params) {
  return request({
    url: '/api/partner',
    method: 'get',
    params
  })
}

export function editPartner(data) {
  return request({
    url: '/api/partner',
    method: 'post',
    data
  })
}

export function deletePartner(data) {
  return request({
    url: '/api/partner',
    method: 'delete',
    data
  })
}

export function editUser(data) {
  return request({
    url: '/api/user',
    method: 'post',
    data
  })
}

export function deleteUser(data) {
  return request({
    url: '/api/user',
    method: 'delete',
    data
  })
}

export function getTransportHeader(params) {
  return request({
    url: '/api/transport/header',
    method: 'get',
    params
  })
}

export function getTransportLine(params) {
  return request({
    url: '/api/transport/line',
    method: 'get',
    params
  })
}
export function getTransportLineList(params) {
  return request({
    url: '/api/transport/line/list',
    method: 'get',
    params
  })
}
export function previewPdf(params) {
  return request({
    url: '/api/transport/header/pdf-excel',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export function saveTransportHeader(data) {
  return request({
    url: '/api/transport/header',
    method: 'post',
    data
  })
}

export function exportTransportLine() {
  return request({
    url: '/api/transport/line/export',
    method: 'get',
    responseType: 'blob'
  })
}

export function saveTransportLine(data) {
  return request({
    url: '/api/transport/line',
    method: 'post',
    data
  })
}

export function deleteTransportLine(data) {
  return request({
    url: '/api/transport/line',
    method: 'delete',
    data
  })
}

export function getBasic(params) {
  return request({
    url: '/api/basic',
    method: 'get',
    params
  })
}

export function editBasic(data) {
  return request({
    url: '/api/basic',
    method: 'post',
    data
  })
}

export function deleteBasic(data) {
  return request({
    url: '/api/basic',
    method: 'delete',
    data
  })
}

export function getPayParams(data) {
  return request({
    url: '/api/pay',
    method: 'post',
    data
  })
}






